
import styled, { css } from "styled-components";
import { colors, transition } from "oolib";

export const StyledFlexWrapper = styled.div`
  display: flex;
  overflow: hidden;
  position: relative;
`;

export const StyledFlexItem = styled.div`
  flex-shrink: 0;
  width: 100%;
  position: relative;
  margin-left: ${({ marginLeft }) => marginLeft};
  ${transition("margin-left")};
`;

const caretCommonCss = css`
  position: absolute;
  cursor: pointer;
  z-index: 100;
  top: ${({ imageMinusCaptionHeight }) =>
    imageMinusCaptionHeight && (imageMinusCaptionHeight / 2)+'px'};
`

export const StyledCaretLeft = styled.div`
  ${caretCommonCss};
  transform: translateY(-50%);
  left: 0;
  
`;

export const StyledCaretRight = styled.div`
  ${caretCommonCss};
  transform: translateY(-50%);
  right: 0;
`;

export const StyledXOfY = styled.div`
  position: absolute;
  top: ${({ imageMinusCaptionHeight }) =>
    imageMinusCaptionHeight && (imageMinusCaptionHeight-10)+'px'};
  border: 1px solid ${colors.greyColor10};
  background-color: ${colors.white_opacity80};
  width: 4rem;
  left: 50%;
  transform: translate(-50%, -100%);        
  text-align: center;
`
